/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/100-drive': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M3 14h10a3 3 0 003-3H0a3 3 0 003 3zm10-2h1v1h-1v-1zm2-10H1l-1 8h16z"/>'
  }
})
